const FA_ICON_STYLE = 'fa-solid'
const FA_OPEN_ICON = 'fa-plus'
const FA_CLOSE_ICON = 'fa-minus'

const createAccordionInstance = (accordion) => {
  const buttonElements = []
  const panelElements = []
  const transitionHandlers = []

  const createAccordionHeader = (titleElement) => {
    const buttonElement = document.createElement('button')
    const iconElement = document.createElement('i')
    const titleContent = document.createElement('span')
    const panelOpen = titleElement.nextElementSibling.classList.contains('show')

    buttonElement.classList.add('sui-accordion-button')
    buttonElement.setAttribute('aria-expanded', panelOpen ? 'true' : 'false')

    iconElement.classList.add(FA_ICON_STYLE, panelOpen ? FA_CLOSE_ICON : FA_OPEN_ICON)
    iconElement.setAttribute('aria-hidden', 'true')
    buttonElement.append(iconElement)

    /*
      Move the user-provided title text into a <span> inside the button
      to match the W3C accordion pattern.
    */
    while (titleElement.firstChild) {
      titleContent.append(titleElement.firstChild)
    }
    titleContent.classList.add('h4')
    buttonElement.prepend(titleContent)

    /*
      Repurpose the original title element as the header container,
      letting the user choose the appropriate heading level (h1, h2, h3, etc).
    */
    titleElement.classList.replace('sui-accordion-title', 'sui-accordion-header')
    titleElement.append(buttonElement)

    buttonElements.push(buttonElement)

    return titleElement
  }

  const createAccordionPanel = (titleElement) => {
    const panelElement = document.createElement('div')
    const panelContentElement = titleElement.nextElementSibling

    panelContentElement.classList.replace('sui-accordion-item', 'sui-accordion-panel-content')
    panelElement.append(panelContentElement)
    panelElement.classList.add('sui-accordion-panel')

    if (panelContentElement.classList.contains('show')) {
      panelElement.style.height = `auto`
      panelElement.style.display = `block`
    }

    panelElements.push(panelElement)

    return panelElement
  }

  const onPanelTransitionEnd = (transitionEndCallback, itemIndex) => {
    const panelElement = panelElements[itemIndex]

    if (transitionHandlers[itemIndex]) {
      panelElement.removeEventListener('transitionend', transitionHandlers[itemIndex])
    }

    const transitionEndHandler = () => {
      transitionEndCallback()
      panelElement.removeEventListener('transitionend', transitionEndHandler)
    }

    transitionHandlers[itemIndex] = transitionEndHandler
    panelElement.addEventListener('transitionend', transitionEndHandler)
  }

  const openPanel = (itemIndex) => {
    const buttonElement = buttonElements[itemIndex]
    const panelElement = panelElements[itemIndex]

    buttonElement.setAttribute('aria-expanded', 'true')
    buttonElement.querySelector(`.${FA_ICON_STYLE}`).classList.replace(FA_OPEN_ICON, FA_CLOSE_ICON)
    panelElement.style.display = `block`
    panelElement.style.height = `${panelElement.scrollHeight}px`

    onPanelTransitionEnd(() => {
      panelElement.style.height = 'auto'
    }, itemIndex)
  }

  const closePanel = (itemIndex) => {
    const buttonElement = buttonElements[itemIndex]
    const panelElement = panelElements[itemIndex]

    buttonElement.setAttribute('aria-expanded', 'false')
    buttonElement.querySelector(`.${FA_ICON_STYLE}`).classList.replace(FA_CLOSE_ICON, FA_OPEN_ICON)
    panelElement.style.height = `${panelElement.scrollHeight}px`

    /*
      Force a reflow to ensure the browser registers the height change before
      starting the transition.
    */
    panelElement.offsetHeight // eslint-disable-line no-unused-expressions
    panelElement.style.height = '0px'

    onPanelTransitionEnd(() => {
      panelElement.style.display = 'none'
    }, itemIndex)
  }

  const bindAccordionEvents = (itemIndex) => {
    buttonElements[itemIndex].addEventListener('click', (e) => {
      const targetButtonElement = e.currentTarget

      buttonElements.forEach((currentButtonElement, index) => {
        const currentButtonIsOpen = currentButtonElement.getAttribute('aria-expanded') === 'true'

        if (currentButtonIsOpen) {
          closePanel(index)
        } else if (targetButtonElement === currentButtonElement) {
          openPanel(index)
        }
      })
    })
  }

  const createAccordionItem = (titleElement, itemIndex) => {
    const headerElement = createAccordionHeader(titleElement, itemIndex)
    const panelElement = createAccordionPanel(titleElement, itemIndex)

    const itemElement = document.createElement('div')
    itemElement.classList.add('sui-accordion-item')
    itemElement.append(headerElement)
    itemElement.append(panelElement)

    bindAccordionEvents(itemIndex)

    return itemElement
  }

  accordion.querySelectorAll('.sui-accordion-title').forEach((titleElement, itemIndex) => {
    accordion.append(createAccordionItem(titleElement, itemIndex))
  })
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sui-accordion').forEach((accordion) => {
    createAccordionInstance(accordion)
  })
})
